import * as axios from 'axios';

const path = 'cep'

const CEPService = {
    // BUSCAR CEP
    find: async cep => await axios.get(`${path}/${cep}`),
}

export default CEPService;